<bb-period-selector-ui [periodStart]="periodStartDate" [periodEnd]="periodEndDate"></bb-period-selector-ui>
